import { Box, Drawer, Stack, Typography } from "@mui/material";
import React from "react";
import { NavLink } from "react-router-dom";
import { menuItems } from "../../config/menu.config";

export const SIDEBAR_WIDTH = 200;

export interface SideBarProps {
  mobileOpen: boolean;
  onClose: () => void;
}

export const SideBarComponent: React.FC<SideBarProps> = ({
  mobileOpen,
  onClose,
}) => {
  const content = (
    <Box
      sx={{
        width: SIDEBAR_WIDTH,
        backgroundColor: "#FFFDF7",
        height: "100%",
        borderRight: "1px solid #eee",
        paddingTop: "10px",
      }}
    >
      {/* Logo */}
      <Box sx={{ paddingX: "12px", marginBottom: "8px" }}>
        <img
          src="https://spotsxplorerapp.s3.us-east-1.amazonaws.com/images/logoPng.png"
          alt="Logo"
          style={{ width: "100%", objectFit: "contain", height: "auto" }}
        />
      </Box>

      {/* Menu */}
      <Stack spacing={0.5} sx={{ paddingX: "12px" }}>
        {menuItems.map((item) => (
          <NavLink
            key={item.key}
            to={item.path}
            onClick={onClose}
            style={{ textDecoration: "none" }}
          >
            {({ isActive }) => (
              <Stack
                direction="row"
                spacing={1.25}
                sx={{
                  alignItems: "center",
                  paddingY: "7px",
                  paddingX: "10px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  color: isActive ? "#ff007f" : "#333",
                  fontWeight: isActive ? "bold" : "normal",
                  backgroundColor: isActive ? "#ffe4f2" : "transparent",
                  transition: "all 0.2s",
                  "&:hover": {
                    backgroundColor: "#f7f7f7",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    color: isActive ? "#ff007f" : "#555",
                    "& svg": { fontSize: "1.1rem" },
                  }}
                >
                  {item.icon}
                </Box>

                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: "600",
                    color: isActive ? "#ff007f" : "#555",
                  }}
                >
                  {item.label}
                </Typography>
              </Stack>
            )}
          </NavLink>
        ))}
      </Stack>
    </Box>
  );

  return (
    <>
      {/* Mobile: overlay drawer, toggled by the navbar's hamburger button */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: SIDEBAR_WIDTH,
          },
        }}
      >
        {content}
      </Drawer>

      {/* Desktop: always-visible sidebar */}
      <Box sx={{ display: { xs: "none", md: "block" }, flexShrink: 0 }}>
        {content}
      </Box>
    </>
  );
};
